import React from "react"
import styled from "@emotion/styled"
import tw from "twin.macro"

import { withCartItem } from "./withCartItem"
import { Price } from "../../Price/Price"
import ImageCTA from "../../Image/ImageCTA"
import { Icon } from "../../Icon/Icon"
import { StyledP } from "../../Styled/Text"

const Wrapper = tw.div`w-full flex flex-row justify-between mb-3-2`
const ContentSection = tw.div`flex justify-start w-full pt-2`
const RemoveIcon = styled.span`
  ${tw`absolute z-10 top-0 left-0 -m-1 w-2 h-2 rounded-full bg-dark flex items-center justify-center text-10 text-dark font-body cursor-pointer`}
  & {
    svg,
    img {
      -webkit-filter: invert(100%); /* safari 6.0 - 9.0 */
      filter: invert(100%);
    }
  }
`
const ImageWrapper = styled.div`
  /* ${tw`relative w-5 min-w-5 md:w-8 md:min-w-8 md:h-8`} */
  ${tw`relative`}
  width: 114px;
  height: 114px;
`
const ImageWrapperInner = styled.div`
  ${tw`relative w-full h-full overflow-hidden`}
  width: 114px;
  height: 114px;
`
const ContentWrapper = styled.div`
  margin-left: 24px;
`
const QtyPriceWrapper = styled.div`
  display: flex;
  align-items: center;
  padding-top: 24px;
`
const Content = styled.div`
  ${tw`flex flex-col justify-between pt-0-5`}
`
const SubtitleWrapper = styled.div`
  ${tw`flex flex-row items-start`}
`
const Title = tw(StyledP)`mb-0-5 capitalize`
const PriceWrapper = styled.div`
  ${tw`mr-1 inline-block md:block`}
  margin-left: 24px;
`
const Subtitle = tw.div`mr-1`
const QuantitySelector = styled.div<QuantitySelectorProps>`
  ${({ layout }) => {
    if (layout === "drawer") return tw`w-8 min-w-8 h-4`
  }}
  ${tw`border border-dark rounded-1 px-1 flex items-center bg-light hover:bg-lightest justify-between transition-all duration-slow`}
  ${({ loading }) => (loading === "true" ? tw`opacity-25 pointer-events-none` : ``)}
`

const QuantityAmount = tw.p`
  text-center text-18 mb-0-2
`

const QuantityButton = tw.button`
  focus:outline-none
`

export const CartItem = withCartItem(
  ({ item, loading, handleQuantity, handleRemove, image }): JSX.Element => (
    <Wrapper>
      <ContentSection>
        <ImageWrapper>
          <RemoveIcon onClick={handleRemove}>
            <Icon name={`cross`} size={10} ratio={`1/1`} />
          </RemoveIcon>
          <ImageWrapperInner>
            <ImageCTA image={image} objectFit={`fill`} />
          </ImageWrapperInner>
        </ImageWrapper>
        <ContentWrapper>
          <Content>
            <Title>{item?.title}</Title>
            <SubtitleWrapper>
              {item?.variant?.title && item.variant.title.toLowerCase() !== "default title" && (
                <Subtitle className="body_small">{item?.variant?.title}</Subtitle>
              )}
            </SubtitleWrapper>
          </Content>
          <QtyPriceWrapper>
            <QuantitySelector layout={`drawer`} loading={loading ? "true" : "false"}>
              <QuantityButton disabled={loading || item?.quantity <= 1} onClick={() => handleQuantity(item?.quantity - 1)}>
                <Icon name={`minus`} size={14} />
              </QuantityButton>
              <QuantityAmount>{item?.quantity}</QuantityAmount>
              <QuantityButton disabled={loading} onClick={() => handleQuantity(item?.quantity + 1)}>
                <Icon name={`plus`} size={14} />
              </QuantityButton>
            </QuantitySelector>
            <PriceWrapper className="title_small">
              <Price price={item?.variant?.priceV2} compareAtPrice={item?.variant?.compareAtPriceV2 || undefined} layout={`product`} />
            </PriceWrapper>
          </QtyPriceWrapper>
        </ContentWrapper>
      </ContentSection>
    </Wrapper>
  )
)

type QuantitySelectorProps = {
  layout: "drawer" | null
  loading: "true" | "false"
}
